<template>
  <quick-tips :tips="tips"/>
</template>

<script>
import QuickTips from '@/components/QuickTips.vue';

export default {
  components: {
    QuickTips,
  },
  data() {
    return {
      tips: [],
    };
  },
  created() {
    this.tips = [
      {
        body: [
          `The properties displayed on this tab are specific to Person ID. Under default 
          properties, the assignment/indexing mode should be Lifetime ID for a single ID 
          assigned to a person across a person’s lifetime including their span from early 
          childhood to student to staff. Context ID would be used when the state 
          administration wishes to assign persons with one ID as a student and a different 
          ID when they become a staff member. Once Lifetime or Context ID is selected by 
          the state administration, the assignment/indexing mode should not be changed.`,
          `Matching rules and other validations for Person ID are available in Rule Manager.`,
        ],
      },
    ];
  },
};
</script>

<style lang="sass" scoped>
</style>
